var $ = require("jquery");

$(document).ready(function() {
  if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent) === false) {
    return;
  }

  document.querySelector("body").classList.add("this-is-ie11");

  fixAccordion();
  checkBrowser();
});

function fixAccordion() {
  $(".accordion__image").css("right", "-120px");
}

function checkBrowser() {
  if ("objectFit" in document.documentElement.style === false) {
    $("img.polyfill-object-fit-cover").each(function() {
      var $this = $(this);

      var source = $this.data("src");
      var parent = $this.parent();

      if ("objectFit" in $this[0].style === false) {
        parent.css("background", "url(" + source + ")");
        parent.css("background-size", "cover");
        $this.css("display", "none");
      } else {
        parent.css("background", "url(" + source + ")");
        parent.css("background-size", "cover");
        parent.css("background-position", "center center");
        $this.css("display", "none");
      }
    });
  }
}
